var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('v-footer',{staticClass:"__footer"},[_c('v-flex',{staticClass:"text-xs-center"},[_vm._v("Bond © "+_vm._s(new Date().getFullYear())+". Open Source Project.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }